/**
 * Created by charnjeetelectrovese@gmail.com on 12/27/2019.
 */

import {serviceFetchUserDeals} from '../services/UserDeals.service';
// import { fetchUserDeals } from '../services/User.service';
import store from '../store';
import Constants from '../config/constants';

export const FETCH_INIT = 'FETCH_INIT_USER_DEALS';
export const FETCHED = 'FETCHED_USER_DEALS';
export const FETCHED_FAIL = 'FETCHED_FAIL_USER_DEALS';
export const FETCHED_FILTER = 'FETCHED_FILTER_USER_DEALS';
// export const NEXT_USER_DEALS = 'NEXT_USER_DEALS';
// export const PREV_USER_DEALS = 'PREV_USER_DEALS';
export const FETCH_NEXT = 'FETCH_NEXT_USER_DEALS';
export const FILTER = 'FILTER_USER_DEALS';
export const RESET_FILTER = 'RESET_FILTER_USER_DEALS';
export const SET_SORTING = 'SET_SORTING_USER_DEALS';
export const SET_FILTER = 'SET_FILTER_USER_DEALS';
export const SET_PAGE = 'SET_PAGE_USER_DEALS';
export const CHANGE_PAGE = 'CHANGE_PAGE_USER_DEALS';
export const CHANGE_STATUS = 'CHANGE_STATE_USER_DEALS';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_USER_DEALS';
export const SET_USERDEAL_REQUEST_TYPE = 'SET_USERDEAL_REQUEST_TYPE';

export function actionFetchUserDeals(index = 1, sorting = {}, filter = {}, shouldReset=false,type) {
    const request = serviceFetchUserDeals({index, row: sorting.row, order: sorting.order, type,  ...filter});
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
            if (!type) {
                dispatch({type: SET_USERDEAL_REQUEST_TYPE, payload: 'ALL'});
            }
        }
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: {data: data.data, page: index}});
                dispatch({type: SET_SERVER_PAGE, payload: index});
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}


export function actionChangePageUserDeals(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

export function actionSetUserDealsRequestType(type){
    return (dispatch) => {
        dispatch({type: SET_USERDEAL_REQUEST_TYPE, payload: type});
    }
}

// export function nextUserDealsClick() {
//     return {
//         type: NEXT_USER_DEALS,
//         payload: null,
//     };
// }
//
// export function prevUserDealsClick() {
//     return {
//         type: PREV_USER_DEALS,
//         payload: null,
//     };
// }

export function actionFilterUserDeals(value) {
    const request = serviceFetchUserDeals(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});
        });
    };
}


export function actionChangeStatusUserDeals(params) {
    console.log('params', params);
    return (dispatch) => {

        dispatch({
            type: CHANGE_STATUS, payload: {
                id: params.id,
                status: params.status,
                note: params.note ? params.note : '',
            }
        });
    };
}

export function actionResetFilterUserDeals() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageUserDeals(page) {
    const stateData = store.getState().user_deals;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;
    const type = stateData.type;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchUserDeals(serverPage + 1, sortingData, {query, query_data: queryData}, false, type));
        // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    }

    console.log(currentPage, totalLength);
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
    // if (this.props.totalUsers <= ((this.props.currentPage + 1) * 100)) {
    //         // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order);
    //         this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    //     }

}
